import { render, staticRenderFns } from "./EditBlackListUserComponent.vue?vue&type=template&id=bb41e008"
import script from "./EditBlackListUserComponent.vue?vue&type=script&lang=js"
export * from "./EditBlackListUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports